import React from 'react';
import { motion } from 'framer-motion';

const IconLoader = () => {
  const polygonVariants = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: {
        duration: 2,
        ease: 'easeInOut',
      },
    },
  };

  const textVariants = {
    hidden: { scale: 0.5, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        delay: 1.5,
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <svg width="200" height="200" viewBox="0 0 100 100">
      <motion.polygon
        points="50,10 80,30 80,70 50,90 20,70 20,30"
        fill="none"
        stroke="#38f9d7"
        strokeWidth="3"
        initial="hidden"
        animate="visible"
        variants={polygonVariants}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <motion.text
        x="50%"
        y="55%"
        textAnchor="middle"
        fill="#38f9d7"
        fontSize="40"
        fontFamily="Arial"
        dominantBaseline="middle"
        variants={textVariants}
        initial="hidden"
        animate="visible">
        AI
      </motion.text>
    </svg>
  );
};

export default IconLoader;
